import { useTranslation } from 'react-i18next'
import { useMediaQuery } from 'usehooks-ts'

import { cn } from '@shared/lib/cn'
import Button from '@shared/ui/button'

import { useFeedbackModal } from '..'

import styles from './styles.module.scss'

export interface FeedbackProps {
  className?: string;
}

export default function Feedback (props: FeedbackProps) {
  const { className } = props
  const isTablet = useMediaQuery('(max-width: 991px)')
  const { t } = useTranslation('common')
  const { openFeedbackModal } = useFeedbackModal()

  return (
    <div className={cn(styles.root, className)}>
      <div className={styles.root__inner}>
        <h3 className={styles.root__title}>{t('feedback.title')}</h3>
        <p className={styles.root__desc}>{t('feedback.desc')}</p>
        <Button
          className={styles.root__button}
          size={isTablet ? 'medium' : 'large'}
          onClick={openFeedbackModal}
        >
          {t('feedback.button')}
        </Button>
      </div>
    </div>
  )
}
